const leagueIdOverride = {
    103: 159,
    104: 160
};

const getLeagueLogoId = (id) => {
    return leagueIdOverride[id];
};

export default getLeagueLogoId;
